export default "__VITE_ASSET__CDXYghEH__"